module.exports = __webpack_public_path__ + "static/media/intro-screen-bg.233183dd.png";